define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.articleStatusFilter = void 0;
    var articleStatusFilter = function (status) {
        var statusMap = {
            published: 'success',
            draft: 'info',
            deleted: 'danger'
        };
        return statusMap[status];
    };
    exports.articleStatusFilter = articleStatusFilter;
});
//# sourceMappingURL=FiltersArticleStatus.js.map